import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import pl from "./locales/pl/translation.json";
import en from "./locales/en/translation.json";

export const SUPPORTED_LANGUAGES = ["pl", "en"] as const;
export type AppLanguage = typeof SUPPORTED_LANGUAGES[number];
export const LANGUAGE_STORAGE_KEY = "academiq_demo_language";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    fallbackLng: "pl",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export const changeAppLanguage = async (language: AppLanguage) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  await i18n.changeLanguage(language);
  // Demo mock content is localized at fetch time — reload so lists/details refetch.
  window.location.reload();
};

export default i18n;
